import React, {useEffect, useState} from "react";
import withNavbar from "../../../common/HOC/NavbarContainerHOC";
import {FormikProps, withFormik} from "formik";
import * as Yup from "yup";
import InputWithLabel from "../../../common/form/InputWithLabel";
import BackButton from "../../../common/button/BackButton";
import SubmitButton from "../../../common/form/SubmitButton";
import {onFailAction, onSuccessAction} from "../../../../helpers/SwalCommon";
import VersionTokenServices from "../../../../services/version-token/VersionTokenServices";
import SelectBox from "../../../common/form/SelectBox";
import ProviderCategoryService from "../../../../services/ProviderCategory/ProviderCategoryService";
import {RouteComponentProps} from "react-router-dom";

interface FormValues {
    code: string;
    note: string;
    provider_id: string;
    type: string;
}

interface OtherProps
    extends RouteComponentProps<{
        id: string;
    }> {
}

type Props = OtherProps & FormikProps<FormValues>;

const VersionTokenUpdate: React.FC<Props> = props => {
    const id = props.match.params.id;
    
    const [providerList, setProviderList] = useState({});
    
    const {code, note, provider_id, type} = props.values;
    
    const fetchProviderOption = async () => {
        const service = new ProviderCategoryService();
        const result = await service.all();
        const options = {};
        result.data.forEach(element => {
            options[element.id] = element.name;
        });
        setProviderList(options);
    };
    
    const onFetchData = async () => {
        const service = new VersionTokenServices();
        const versionToken = await service.find(id);
        for (let key in versionToken.data) {
            props.setFieldValue(key, versionToken.data[key]);
        }
    };
    
    useEffect(() => {
        fetchProviderOption();
        onFetchData();
        // eslint-disable-next-line
    }, []);
    
    const changeProviderId = (e) => {
        props.setFieldValue("provider_id", e)
    }
    return (
        <div className="card">
            <h4 className="card-title1 ml-3">Cập nhật nhà cung cấp</h4>
            <div className="card-body">
                <form>
                    <div className="input-group">
                        <InputWithLabel
                            name="code"
                            label="Mã version token"
                            wrapClass="col-md-4 form-group"
                            onChangeValue={props.handleChange}
                            value={code}
                            error={props.errors.code}
                            isRequired={true}
                            maxLength={255}
                        />
                        <InputWithLabel
                            name="type"
                            label="Loại version token"
                            wrapClass="col-md-4 form-group"
                            onChangeValue={props.handleChange}
                            value={type}
                            error={props.errors.type}
                            isRequired={true}
                            maxLength={255}
                        />
                        <SelectBox
                            name="provider_id"
                            options={providerList}
                            label="Nhà cung cấp"
                            wrappedClass="col-md-4"
                            firstOptionLabel="Chọn nhà cung cấp"
                            onChange={changeProviderId}
                            value={provider_id}
                            error={props.errors.provider_id}
                            isRequired={true}
                        />
                    </div>
                    <div className="input-group">
                        <InputWithLabel
                            name="note"
                            label="Ghi chú"
                            wrapClass="col-md form-group"
                            onChangeValue={props.handleChange}
                            value={note}
                            error={props.errors.note}
                        />
                    </div>
                    <div className="input-group d-flex justify-content-center p-5">
                        <BackButton
                            history={props.history}
                            // url="/danh-muc-version-token"
                        />
                        <SubmitButton onClick={props.handleSubmit}/>
                    </div>
                </form>
            </div>
        </div>
    );
};

const RenderCreateForm = withFormik<Props, FormValues>({
    mapPropsToValues: () => ({
        code: "",
        note: "",
        provider_id: "",
        type: "",
    }),
    validationSchema: Yup.object().shape({
        code: Yup.string().required("Mã không thể bỏ trống."),
        provider_id: Yup.string().required("Nhà cung cấp không thể bỏ trống.")
    }),
    validateOnBlur: false,
    validateOnChange: false,
    enableReinitialize: true,
    handleSubmit: async (values, {setSubmitting, props, setErrors}) => {
        setSubmitting(false);
        const service = new VersionTokenServices();
        const result = await service.update({
            ...values,
            id: props.match.params.id
        });
        if (result.status === 200) {
            onSuccessAction("Cập nhật Version Token thành công!", function () {
                props.history.goBack();
            });
        } else if (result.status === 422) {
            setErrors(result.error);
        } else {
            onFailAction(result.error);
        }
    }
})(VersionTokenUpdate);

export default withNavbar()(RenderCreateForm);
